import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-search',
  templateUrl: './nav-search.component.html',
  styleUrls: ['./nav-search.component.scss']
})
export class NavSearchComponent implements OnInit {
  public isSearch: boolean;

  constructor(private router: Router) { }

  ngOnInit() { }

  search(event) {
    console.log("integration=>",window.localStorage.getItem("integration_type"));
    if (window.localStorage.getItem("integration_type") == "1") {
      this.router.navigateByUrl('trackpayout/report/search/' + event.target.value);
      this.isSearch = false;
    }else{
      this.router.navigateByUrl('trackpayout/report-tally/search/' + event.target.value);
      this.isSearch = false;
    }
    
  }

}
